(function (root, factory) {
  var rules = factory();
  if (typeof module === 'object' && module.exports) module.exports = rules;
  else root.KMCartGiftRules = rules;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function isModernGift(item) {
    return String(item && item.properties && item.properties._km_cart_gift) === 'true';
  }

  function isLegacyGift(item) {
    var properties = item && item.properties || {};
    return String(properties._uc_is_gift || '').trim() === '1'
      || Boolean(properties._uc_pick_section)
      || String(item && (item.variant_id || item.id) || '') === '45494484697279';
  }

  function normalizeConfig(raw) {
    if (!raw || raw.version !== 1 || !Array.isArray(raw.gifts)) {
      throw new Error('Invalid cart gift configuration');
    }
    var diagnostics = [];
    var seenVariants = new Set();
    var gifts = [];
    raw.gifts.forEach(function (gift) {
      var threshold = Math.round(Number(gift && gift.thresholdCents));
      if (!gift || gift.enabled === false || !gift.id || !Number.isFinite(threshold) || threshold <= 0) {
        diagnostics.push('Invalid gift block');
        return;
      }
      var variants = (Array.isArray(gift.variants) ? gift.variants : []).filter(function (variant) {
        var id = String(variant && variant.id != null ? variant.id : '').trim();
        if (!id || seenVariants.has(id)) {
          diagnostics.push('Duplicate or missing variant: ' + id);
          return false;
        }
        var value = Object.prototype.hasOwnProperty.call(variant, 'thresholdCents') ? variant.thresholdCents : threshold;
        var variantThreshold = Math.round(Number(value));
        var numeric = typeof value === 'number'
          || typeof value === 'string' && /^\d+(\.\d+)?$/.test(value.trim());
        if (!numeric || !Number.isFinite(variantThreshold) || variantThreshold <= 0) {
          diagnostics.push('Invalid variant threshold: ' + id);
          return false;
        }
        seenVariants.add(id);
        return true;
      }).map(function (variant) {
        return Object.assign({}, variant, {id: String(variant.id), available: variant.available === true,
          thresholdCents: Object.prototype.hasOwnProperty.call(variant, 'thresholdCents')
            ? Math.round(Number(variant.thresholdCents)) : threshold});
      });
      if (!variants.length) {
        diagnostics.push('No allowed variants: ' + gift.id);
        return;
      }
      var availableVariants = variants.filter(function (variant) { return variant.available; });
      var displayVariants = availableVariants.length ? availableVariants : variants;
      gifts.push(Object.assign({}, gift, {id: String(gift.id), thresholdCents: threshold,
        displayThresholdCents: Math.min.apply(null, displayVariants.map(function (variant) { return variant.thresholdCents; })),
        variants: variants}));
    });
    var excludedSkus = Array.isArray(raw.excludedSkus) ? raw.excludedSkus : [];
    return Object.assign({}, raw, {
      enabled: raw.enabled === true,
      gifts: gifts,
      thresholds: Array.from(new Set(gifts.reduce(function (values, gift) {
        return values.concat(gift.variants.map(function (variant) { return variant.thresholdCents; }));
      }, [])))
        .sort(function (a, b) { return a - b; }),
      excludedSkus: Array.from(new Set(excludedSkus.map(function (sku) {
        return String(sku || '').trim().toUpperCase();
      }).filter(Boolean))),
      autoOpen: raw.autoOpen || {},
      messages: raw.messages || {},
      diagnostics: diagnostics
    });
  }

  function lineAmount(item) {
    var fields = ['final_line_price', 'line_price', 'original_line_price'];
    for (var i = 0; i < fields.length; i += 1) {
      var value = item[fields[i]];
      if (value != null && Number.isFinite(Number(value))) return Math.max(0, Math.round(Number(value)));
    }
    return 0;
  }

  function getEligibleSubtotal(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    if (!items.length || Number(cart.item_count) === 0) return 0;
    return Math.max(0, items.reduce(function (subtotal, item) {
      var excluded = config.excludedSkus.indexOf(String(item.sku || '').trim().toUpperCase()) !== -1;
      return excluded || isModernGift(item) || isLegacyGift(item) ? subtotal - lineAmount(item) : subtotal;
    }, Math.max(0, Math.round(Number(cart.total_price) || 0))));
  }

  function getProgress(subtotal, thresholds) {
    var total = Math.max(0, Number(subtotal) || 0);
    if (!thresholds.length) return {percent: 0, nextThreshold: null, shortfall: 0, unlockedThresholds: []};
    var index = thresholds.findIndex(function (value) { return total < value; });
    if (index === -1) return {percent: 100, nextThreshold: null, shortfall: 0, unlockedThresholds: thresholds.slice()};
    var previous = index === 0 ? 0 : thresholds[index - 1];
    var next = thresholds[index];
    return {
      percent: ((index + (total - previous) / (next - previous)) / thresholds.length) * 100,
      nextThreshold: next, shortfall: next - total, unlockedThresholds: thresholds.slice(0, index)
    };
  }

  function findGiftVariant(config, variantId) {
    for (var i = 0; i < config.gifts.length; i += 1) {
      var gift = config.gifts[i];
      var variant = gift.variants.find(function (value) { return value.id === String(variantId); });
      if (variant) return {gift: gift, variant: variant, thresholdCents: variant.thresholdCents};
    }
    return null;
  }

  function getGiftUpdates(cart, config, selectedVariantId) {
    var match = config.enabled ? findGiftVariant(config, selectedVariantId) : null;
    var keep = match && match.variant.available && getEligibleSubtotal(cart, config) >= match.thresholdCents;
    var kept = false;
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (!isModernGift(item) || !item.key) return;
      if (keep && !kept && String(item.variant_id || item.id) === match.variant.id) {
        kept = true;
        if (Number(item.quantity) !== 1) updates[item.key] = 1;
      } else updates[item.key] = 0;
    });
    return updates;
  }

  return {normalizeConfig: normalizeConfig, isModernGift: isModernGift, isLegacyGift: isLegacyGift,
    getEligibleSubtotal: getEligibleSubtotal, getProgress: getProgress,
    findGiftVariant: findGiftVariant, getGiftUpdates: getGiftUpdates};
});
